import { Button, ButtonProps, ElementProps } from "@mantine/core";

export type ToggleButtonProps = ButtonProps &
  Omit<ElementProps<"button", keyof ButtonProps>, "value"> & {
    selected?: boolean;
    value?: string;
  };

/**
 * MUI ToggleButton replacement: a borderless compact text button whose
 * selected state gets the light gray pill background. Group with
 * `<Group gap={8}>` where MUI ToggleButtonGroup laid them out.
 */
const ToggleButton = ({
  selected = false,
  children,
  ...rest
}: ToggleButtonProps) => (
  <Button
    variant={selected ? "light" : "subtle"}
    color="gray"
    size="compact-md"
    radius={4}
    fz="sm"
    fw={500}
    c={
      selected
        ? "var(--mantine-color-text-primary)"
        : "var(--mantine-color-text-secondary)"
    }
    aria-pressed={selected}
    styles={{ label: { whiteSpace: "nowrap" } }}
    {...rest}
  >
    {children}
  </Button>
);

export default ToggleButton;
